<script>
import SimpleModal from './SimpleModal.svelte';
export let content = "";
export let onConfirm = function(){};
export let onCancel = function(){};
export let cancel_button = "Cancelar";
export let confirm_button = "Sí";
export let classesCancel = "is-danger is-outlined";
export let classesConfirm = "is-success has-text-white";
</script>
<style>
.footer{
    padding: 0;
    background-color: transparent;
}
.content{
    margin: 0;
}
</style>
<SimpleModal let:hide={hide} active={true} styles="min-width:320px;max-width:485px;width:100%;">
    <div class="content has-text-centered" slot="content">
        {@html content}
    </div>
    <div class="footer" slot="footer">
        <div class="buttons is-grouped is-centered">
            <button on:click={()=>{ hide(); onCancel();}} class="button {classesCancel}">
                {cancel_button}
            </button>
            <button on:click={()=>{ hide(); onConfirm();}} class="button {classesConfirm}">
                {confirm_button}
            </button>
        </div>
    </div>
</SimpleModal>